var _tspan, _tspan2, _tspan3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77.936 28.373",
    height: 107.237,
    width: 294.562,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-169.46 -160.852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.696 178.575c-.59-.073-1.155-.496-1.42-1.063-.144-.306-.147-.332-.154-1.18l-.006-.754h-.184c-.213 0-.232-.01-.279-.152-.036-.11-.335-1.082-.39-1.267a30.146 30.146 0 0 0-.123-.396l-.08-.255v-1.012c0-.69.006-1.023.019-1.047a.182.182 0 0 1 .08-.061l.06-.025v-1.554l.043-.043c.042-.042.051-.043.3-.043.236 0 .256-.002.256-.032 0-.018.02-.052.046-.075l.045-.043.638-.005c.7-.005.707-.004.752.097l.025.057h.234c.252 0 .309.014.34.082.013.03.02.286.02.81 0 .73 0 .766.031.766.018 0 .05.019.072.042l.04.041-.001 1.027v1.027l-.109.356a139.863 139.863 0 0 1-.354 1.15c-.136.44-.158.501-.197.528-.027.02-.085.027-.21.027h-.172v.675c0 .6.004.688.032.791a.869.869 0 0 0 .611.61c.098.03.189.032 1.217.032.838 0 1.135-.006 1.207-.023a.882.882 0 0 0 .664-.67c.021-.1.025-.66.025-3.72v-3.602l.043-.05.043-.049h.729l.043.05.043.05-.005 3.69-.005 3.688-.042.15a1.863 1.863 0 0 1-1.59 1.376c-.203.02-2.162.02-2.337-.001zm2.503-.321c.567-.136.97-.522 1.126-1.08l.04-.14.005-3.585.005-3.585h-.3v3.502c0 3.905.008 3.642-.124 3.914a1.241 1.241 0 0 1-.571.58c-.248.122-.23.12-1.484.123-1.263.004-1.214.007-1.488-.124a.937.937 0 0 1-.32-.232 1.21 1.21 0 0 1-.32-.497c-.04-.11-.041-.138-.05-.828l-.009-.715-.146-.005-.147-.005.006.755.006.755.05.15c.139.417.386.707.76.894.312.156.377.162 1.71.157.977-.004 1.146-.008 1.25-.034zm-2.95-3.12.044-.146-.173-.01c-.148-.006-.178-.014-.212-.047a.15.15 0 0 1 0-.204c.036-.035.062-.04.261-.048l.222-.01.042-.131c.024-.073.043-.139.043-.146 0-.007-.115-.013-.255-.013-.242 0-.257-.002-.303-.042a.14.14 0 0 1 0-.216c.047-.04.058-.042.353-.042h.304l.045-.15.045-.15h-.349c-.342 0-.35 0-.398-.042a.14.14 0 0 1 0-.216c.048-.041.053-.042.444-.042h.396v-.3h-.396c-.39 0-.396 0-.444-.041-.037-.032-.049-.058-.049-.108 0-.05.012-.077.049-.109.048-.04.053-.041.444-.041h.396v-1.2h-.308l-.03.102c-.06.2-.25.43-.45.537a.897.897 0 0 1-.616.077c-.3-.08-.582-.355-.658-.64l-.02-.076h-.316v1.2h.813l.043.043c.047.047.058.139.02.187-.048.063-.093.07-.487.07h-.39v.3h.807l.046.042c.051.048.063.138.024.188-.047.061-.095.069-.434.069-.185 0-.337.006-.336.013 0 .007.019.073.042.146l.042.132.315.009c.173.006.316.012.318.013.083.075.1.165.042.235-.032.04-.046.042-.306.05l-.273.01.045.145.045.146h.2c.202 0 .257.012.3.069.037.048.027.14-.02.187-.04.04-.057.043-.212.043a.607.607 0 0 0-.168.012c0 .016.072.26.082.275.005.007.296.014.648.014h.64zm-.424-3.06a.717.717 0 0 0 .154-.102c.067-.06.162-.217.162-.268 0-.019-.116-.023-.583-.023h-.584l.013.04a.561.561 0 0 0 .34.36c.085.036.122.04.258.036a.651.651 0 0 0 .24-.043zm-.725-.852v-.141h-.08c-.105 0-.176-.038-.2-.108-.012-.035-.02-.221-.02-.503v-.447H209.518v1.34h.582zm.618-.112c0-.247 0-.253.044-.294.033-.031.07-.043.15-.05l.106-.007-.004-.443-.005-.444-.445-.005-.446-.005v.9h.08c.099 0 .18.04.203.1.01.024.017.147.017.272v.228h.3zm.899-.417v-.67h-.3v.475c0 .473 0 .475-.041.523-.035.04-.06.05-.15.056l-.109.008v.278h.6z",
    style: {
      fill: "#dcdcdc",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0176373,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.109 174.079h8.834",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#30AFEF",
      strokeWidth: 0.327976,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: ".983929,.327976",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.464 180.09c-.586-.124-1.096-.453-1.399-.901-.154-.23-.34-.666-.322-.759.01-.057.628-.06 9.26-.06 8.63 0 9.248.003 9.259.06.007.034-.033.172-.087.308-.286.718-.861 1.19-1.652 1.353-.324.067-.579.07-7.539.067-6.86-.002-7.219-.005-7.52-.069zm8.914-.834v-.326h-2.751v.652h2.751zm-8.909-1.705-.105-.112v-4.574c0-3.211.012-4.6.04-4.66a.403.403 0 0 1 .14-.146c.095-.056.66-.06 7.458-.06s7.363.004 7.457.06c.057.033.12.099.142.146.027.06.04 1.449.04 4.66v4.574l-.106.112-.105.112h-14.856zm13.859-4.711.009-3.502h-12.67v3.487c0 1.918.011 3.498.024 3.511.014.014 2.86.02 6.326.015l6.302-.009z",
    style: {
      fill: "none",
      stroke: "#dcdcdc",
      strokeWidth: 0.264583,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#30AFEF",
      strokeWidth: 0.327976,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: ".983929,.327976",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "M217.79 174.079h8.835"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    fill: "none",
    transform: "matrix(.0885 0 0 .0885 173.517 162.035)",
    style: {
      stroke: "#dcdcdc",
      strokeWidth: 2.98949,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.323,
    strokeLinecap: "round",
    style: {
      stroke: "#dcdcdc",
      strokeWidth: 2.98949,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M207.22 77.942c2.15 2.23.726 11.163-.374 13.797 0 0-7.03 27.557-12.59 48.297-5.55 20.705-8.025 36.754-13.432 42.244M1.544 77.94c-2.15 2.23-.725 11.163.374 13.797 0 0 7.03 27.557 12.59 48.297 5.55 20.705 8.025 36.754 13.432 42.244",
    transform: "translate(.089 15.673)",
    style: {
      stroke: "#dcdcdc",
      strokeWidth: 2.98949,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m194.19 139.8-25.102.149c-.768-.705.018-2.082-1.058-2.514h-62.707M15.439 139.8l25.102.149c.768-.705-.018-2.082 1.058-2.514h62.707",
    transform: "translate(-.34 15.748)",
    style: {
      stroke: "#dcdcdc",
      strokeWidth: 2.98949,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.32 90.423.051 23.166c.001.587.072 1.336-.892 1.303l-3.39-.02c.042.838-.564 1.184-1.492 1.189l-8.786.025c-.633-.021-1.199-.219-1.39-1.025l-1.212.008M86.91 90.423l-.051 23.166c-.001.587-.071 1.336.892 1.303l3.39-.02c-.042.838.564 1.184 1.492 1.189l8.786.025c.633-.021 1.199-.219 1.39-1.025l1.212.008",
    transform: "translate(-.142 15.31)",
    style: {
      stroke: "#dcdcdc",
      strokeWidth: 2.98949,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m105.08 182.43 76.673-.08 67.461-1.473s4.232-1.762 4.186-10.448l-.437-83c-.008-1.568.184-6.095-4.133-9.036l-41.606-.448-27.927 12.038-56.976.443-.137-30.611c-.004-.787-.857-1.826-2.143-1.826h-15.063m-.882 124.44-76.673-.08-67.461-1.473s-4.233-1.762-4.187-10.448l.438-83.001c.008-1.567-.185-6.094 4.132-9.035l41.606-.448 27.927 12.038 56.976.442.137-30.61c.004-.787.858-1.827 2.143-1.827h15.063",
    transform: "translate(-.115 15.436)",
    style: {
      stroke: "#dcdcdc",
      strokeWidth: 2.98949,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.323,
    d: "M214.29 181.9c.065.671-.975.932-1.8.928-7.442.03-5.645.044-7.88.016-1.025-.005-1.673-.34-1.662-.85m-208.85-.094c-.065.671.975.932 1.8.928 7.442.03 5.644.044 7.879.015 1.026-.005 1.674-.339 1.663-.85",
    transform: "translate(.281 15.865)",
    style: {
      stroke: "#dcdcdc",
      strokeWidth: 2.98949,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 0.933,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    r: 4.668,
    cy: 170.22,
    cx: 223.14,
    style: {
      stroke: "#dcdcdc",
      strokeWidth: 2.98949,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      baselineShift: "baseline",
      textAnchor: "start",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#dcdcdc",
      strokeWidth: 0.132292,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      enableBackground: "accumulate"
    },
    d: "M210.987 160.918h3.439c1.028 0 1.852.823 1.852 1.852a1.845 1.845 0 0 1-1.852 1.852H210.988v-3.704z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.363 162.77a.132.132 0 1 0 .265 0 .132.132 0 0 0-.265 0zm.283.373.187.187a.797.797 0 0 0 .217-.562.76.76 0 0 0-.22-.562l-.18.193c.086.08.136.22.135.367a.549.549 0 0 1-.139.377zm.375.374.187.187c.241-.241.358-.591.36-.937.003-.347-.11-.697-.36-.932l-.182.193c.182.17.28.45.277.737-.003.286-.103.573-.282.752zm.374.375.187.187c.335-.335.498-.827.501-1.314.003-.488-.156-.978-.504-1.304l-.18.193c.278.261.422.681.42 1.11-.003.427-.152.856-.424 1.128zM208.39 164.08v-2.62a.09.09 0 0 1 .05-.013h1.803v2.646h-1.804a.088.088 0 0 1-.049-.013zm.53-.252h.793v-.794h-.793v.662zm0-1.323h.793v-.794h-.793v.662zm.264 1.059v-.265h.265v.265zm0-1.323v-.265h.265v.265zm1.323 2.116v-3.175h.265v3.175z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      baselineShift: "baseline",
      textAnchor: "start",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#dcdcdc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.264583,
      strokeOpacity: 1,
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.964 189.083c-1.173-.168-2.111-.968-2.503-2.132-.133-.398-.126-1.355.014-1.778.142-.427.35-.79.63-1.103.215-.24.253-.264.44-.264.169 0 .227.027.343.156.19.213.18.38-.036.664-.618.81-.73 1.55-.357 2.354.157.338.573.78.88.938a2.084 2.084 0 0 0 2.493-.431c.281-.308.391-.51.494-.906.169-.652.014-1.32-.433-1.866-.23-.28-.274-.424-.191-.622a.45.45 0 0 1 .554-.27c.317.094.796.808.99 1.473.122.42.109 1.195-.028 1.63a2.866 2.866 0 0 1-.768 1.275c-.572.578-1.161.845-1.946.883a4.43 4.43 0 0 1-.576 0zm.052-3.673-.124-.148v-1.29c0-.864.018-1.332.055-1.412a.517.517 0 0 1 .22-.2c.146-.068.189-.07.342-.013.317.12.343.236.344 1.535 0 .624-.014 1.202-.03 1.284-.05.25-.22.391-.468.391-.18 0-.234-.023-.339-.148z",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#dcdcdc",
      strokeWidth: 0.264583,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.19 169.59 7.651-4.416",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#30AFEF",
      strokeWidth: 0.328,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: ".984,.328",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.19 179.428 7.651 4.417",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#30AFEF",
      strokeWidth: 0.327975,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: ".98393,.327975",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#17171e",
      fillOpacity: 1,
      stroke: "#30AFEF",
      strokeWidth: 0.121831,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 10,
      strokeOpacity: 1
    },
    cx: 202.526,
    cy: 173.98,
    r: 1.401
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.058)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#17171e",
      fillOpacity: 1,
      stroke: "#30AFEF",
      strokeWidth: 0.121831,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 10,
      strokeOpacity: 1
    },
    cx: 200.883,
    cy: 167.329,
    r: 1.401
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "2.11667px",
      lineHeight: 1.25,
      fontFamily: "Roboto",
      InkscapeFontSpecification: "'Roboto, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#30AFEF",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.265,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    x: 200.265,
    y: 168.055
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 200.265,
    y: 168.055,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "2.11667px",
      fontFamily: "Roboto",
      InkscapeFontSpecification: "'Roboto, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#30AFEF",
      fillOpacity: 1,
      strokeWidth: 0.265,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "2.11667px",
      lineHeight: 1.25,
      fontFamily: "Roboto",
      InkscapeFontSpecification: "'Roboto, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#30AFEF",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.264999,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    x: 201.965,
    y: 174.706
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    y: 174.706,
    x: 201.965
  }, "2"))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#17171e",
      fillOpacity: 1,
      stroke: "#30AFEF",
      strokeWidth: 0.121831,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 10,
      strokeOpacity: 1
    },
    cx: 222.208,
    cy: 174.03,
    r: 1.401
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "2.11667px",
      lineHeight: 1.25,
      fontFamily: "Roboto",
      InkscapeFontSpecification: "'Roboto, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#30AFEF",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.264999,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    x: 221.634,
    y: 174.755
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    y: 174.755,
    x: 221.634
  }, "3"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.296 -1.62)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1.401,
    cy: 183.29,
    cx: 201.646,
    style: {
      fill: "#17171e",
      fillOpacity: 1,
      stroke: "#30AFEF",
      strokeWidth: 0.121831,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 10,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: 184.042,
    x: 201.048,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "2.11667px",
      lineHeight: 1.25,
      fontFamily: "Roboto",
      InkscapeFontSpecification: "'Roboto, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#30AFEF",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.264999,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    xmlSpace: "preserve"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 201.048,
    y: 184.042
  }, "4"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.27ea4e20a23a529efd4614864fddd9bf.svg";
export { ForwardRef as ReactComponent };